import { daysUntil, formatDate } from '@/lib/time';

// Formato de la columna "Próxima revisión". La revisión es una fecha pura (el backend
// la fija a medianoche UTC) y se muestra dd/mm/aaaa; "hoy" es el día de negocio.

export type ReviewTone = 'danger' | 'normal' | 'muted';

export interface ReviewDateLabel {
  text: string;
  tone: ReviewTone;
}

export function formatReviewDate(nextReviewAt: string | null, now: Date): ReviewDateLabel {
  if (!nextReviewAt) {
    return { text: 'n/d', tone: 'muted' };
  }
  // Días de negocio (Costa Rica): de noche en UTC ya es mañana y marcaría "hace 1 día".
  const diff = daysUntil(nextReviewAt, now);
  if (diff === null) {
    return { text: 'n/d', tone: 'muted' };
  }
  if (diff < 0) {
    const n = Math.abs(diff);
    return { text: `hace ${n} ${n === 1 ? 'día' : 'días'}`, tone: 'danger' };
  }
  if (diff === 0) {
    return { text: 'vence hoy', tone: 'danger' };
  }
  return { text: formatDate(nextReviewAt), tone: 'normal' };
}

/** Versión de la columna "Ver." del mockup: v{n}, o "n/d" si no hay versión. */
export function formatVersion(version: number | null, status: string): string {
  if (version === null) {
    return status === 'borrador' ? 'v1 · borrador' : 'n/d';
  }
  return `v${version}`;
}
